import { BaseRes } from 'bff/models/base/baseRes';
import { actionTypes, BaseAction } from 'redux/actions';
import { takeEvery, call, put } from 'redux-saga/effects';
import { Favorites, Favorite, AddFavoriteItem } from 'bff/models/member';
import apiService from 'bff/services/apiService';
import { BaseReq } from 'bff/models/base/baseReq';
import { AxiosRequestConfig } from 'axios';
import { ApplicationId } from 'constants/enums/applicationId.enum';
import { fetchMyFavoriteComplete, fetchMyFavorite as fetchMyFavoriteAction, addFavoriteItem } from 'redux/actions/components/myFavorite.action';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import _ from 'lodash';
import { InsType } from 'constants/enums/insType.enum';
// import moment from 'moment';
import moment from 'moment-timezone';

export function * watchFetchMyFavoriteData () {
  yield takeEvery(actionTypes.MYFAVORITE.FETCH_MY_FAVORITE, fetchMyFavorite);
  yield takeEvery(actionTypes.MYFAVORITE.ADD_FAVORITE_ITEM, addFavorite);
  yield takeEvery(actionTypes.MYFAVORITE.REMOVE_FAVORITE_ITEM, removeFavorite);
}

let baseReq:BaseReq<any> = {
  MWHEADER: {
    // ApplicationId: ApplicationId.FrontEnd
  },
  TRANRQ: {

  }
};

let reqConfig:AxiosRequestConfig = {
  headers: {
    ApplicationId: ApplicationId.FrontEnd
  }
};

// /**
//  * @description 取得我的收藏
//  */
// function * fetchMyFavorite (action:BaseAction) {
//   const fetchMyFavoriteResult:BaseRes<Favorites> = yield call(apiService.fetchMyFavorite, baseReq, reqConfig, action.payload.MemberId);
//   const fetchRecommandsResult:BaseRes<Recommands> = yield call(apiService.fetchRecommands, baseReq, reqConfig);

//   // 有點加入我的收藏後登入，進行判斷有無已存在，如無則新增
//   if (action.payload.AddItem) {
//     const addItem:AddFavoriteItem = { ...action.payload.AddItem };
//     const exist = _.some(fetchMyFavoriteResult.TRANRS.FAVORITE, (favorite:Favorite) =>
//       favorite.INS_TYPE_ID === addItem.INS_TYPE_ID &&
//     favorite.PROD_ID === addItem.PROD_ID &&
//     favorite.PLAN_ID === addItem.PLAN_ID);

//     if (!exist) {
//       yield put(addFavoriteItem(addItem));
//     }
//   }

//   // 取得與我的收藏相對應的推薦項目
//   const favoriteItems = fetchFavoriteItems(fetchRecommandsResult.TRANRS.RECOMMANDS, fetchMyFavoriteResult.TRANRS.FAVORITE);

//   if (favoriteItems) {
//     yield put(fetchMyFavoriteComplete([...favoriteItems]));
//   } else {
//     yield put(fetchMyFavoriteComplete(new Array(0)));
//   }
// };

/**
 * @description 取得我的收藏
 */
function * fetchMyFavorite (action:BaseAction) {
  const fetchMyFavoriteResult:BaseRes<Favorites> = yield call(apiService.fetchMyFavorite, baseReq, reqConfig, action.payload.MemberId);

  // 有點加入我的收藏後登入，進行判斷有無已存在，如無則新增
  if (action.payload.AddItem) {
    const addItem:AddFavoriteItem = { ...action.payload.AddItem };
    const exist = _.some(fetchMyFavoriteResult.TRANRS.FAVORITE, (favorite:Favorite) =>
      favorite.INS_TYPE_ID === addItem.INS_TYPE_ID &&
    favorite.PROD_ID === addItem.PROD_ID &&
    favorite.PLAN_ID === addItem.PLAN_ID);

    if (!exist) {
      yield put(addFavoriteItem(addItem));
    }
  }

  // 取得未過期項目
  const favoriteItems = fetchValidItems(fetchMyFavoriteResult.TRANRS.FAVORITE);
  if (favoriteItems) {
    yield put(fetchMyFavoriteComplete([...favoriteItems]));
  } else {
    yield put(fetchMyFavoriteComplete(new Array(0)));
  }
};

/**
 * @description 新增我的收藏
 */
function * addFavorite (action:BaseAction) {
  baseReq = {
    ...baseReq,
    TRANRQ: { ...action.payload }
  };

  yield call(apiService.addFavoriteItem, baseReq, reqConfig);
  yield loadMyFavorite();
};

/**
 * @description 移除我的收藏
 */
function * removeFavorite (action:BaseAction) {
  reqConfig = {
    ...reqConfig,
    data: baseReq
  };

  yield call(apiService.removeFavoriteItem, reqConfig, action.payload);
  yield loadMyFavorite();
};

// /**
//  * @description 取得與我的收藏相對應且未過期的推薦項目 (汽、機車險不判斷)
//  */
// function fetchFavoriteItems (recommandDatas:RecommandData[], favorites:Favorite[]):Favorite[] {
//   _.forEach(recommandDatas, (recommandData:RecommandData) => {
//     // 跳過 汽、機車險
//     if (recommandData.INS_TYPE_ID === InsType.Car || recommandData.INS_TYPE_ID === InsType.Moto) return;

//     _.forEach(recommandData.RECOMMAND, (recommand:Recommand) => {
//       _.remove(favorites, (favorite:Favorite) => {
//         const isExpired = moment() > moment(recommand.END_DATE);

//         return isExpired &&
//         favorite.INS_TYPE_ID === recommandData.INS_TYPE_ID &&
//         favorite.PROD_ID === recommand.PROD_ID &&
//         favorite.PLAN_ID === recommand.PLAN_ID;
//       });
//     });
//   });

//   return favorites;
// };

/**
 * @description 取得與我的收藏相對應且未過期的推薦項目 (汽、機車險不判斷)
 */
function fetchValidItems (favorites:Favorite[]):Favorite[] {
  _.forEach(favorites, (favorite:Favorite) => {
    // 跳過 汽、機車險
    if (favorite.INS_TYPE_ID === InsType.Car || favorite.INS_TYPE_ID === InsType.Moto) return;

    _.remove(favorites, (favorite:Favorite) => {
      return favorite.CONTENT && favorite.CONTENT.END_DATE ? moment() > moment(favorite.CONTENT.END_DATE) : false;
    });
  });
  // console.log('fetchValidItems', favorites);
  return favorites;
};

/**
 * @description 取得我的收藏
 */
function * loadMyFavorite () {
  yield put(fetchMyFavoriteAction(storageService.getItem(storageKeys.MemberId)));
};
